import Axios from "axios";

export default {
    getRelations: () => {
        return Axios.get('/Lookups/relations/')
    },

    getRelationsByDocument: (data) => {
        const params = {
            "DocumentCode":data.DocCode,
            "GenderCode":data.genderCode
        };
        return Axios.get('/Lookups/relations-by-document/',{params:params})

    },

    getAllDocuments: () => {
        return Axios.get('/Lookups/all-documentTypes/')
    },

    nidIssueReasons: () => {
        return Axios.get('/Lookups/nid-issue-reasons/')
    },

    // GOVERNORATE CODES
    GovCodes: () => {
        return Axios.get('/Lookups/govs/')
    },

    PoliceCodesByGov: (govCode) => {
        return Axios.get('/Lookups/police-depts-by-govCode/',{params:{GovCode:govCode.toString()}})
    },

    PostalCodesByGov: (govCode) => {
        return Axios.get('/Lookups/postal-codes-by-govCode/',{params:{GovCode:govCode.toString()}})
    },

    getGenders: () => {
        return Axios.get('/Lookups/genders/')
    },
    getNidFormTypes: () => {
        return Axios.get('/Lookups/nid-form-types/')
    },

    getRegulations: (headers) => {
        return Axios.get('/Lookups/regulations/', {headers:headers})
    }
}